import * as React from 'react'
import type {SVGProps} from 'react'
const Svg401KMaximizer = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={22}
        height={22}
        viewBox="0 0 22 22"
        {...props}
    >
        <defs>
            <path id="401-k-maximizer_svg__a" d="M0 0h22v22H0z" />
        </defs>
        <g fill="none" fillRule="evenodd">
            <mask id="401-k-maximizer_svg__b" fill="#fff">
                <use xlinkHref="#401-k-maximizer_svg__a" />
            </mask>
            <path
                fill="#182744"
                d="M11 0C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11S17.075 0 11 0m0 1.5c5.238 0 9.5 4.262 9.5 9.5s-4.262 9.5-9.5 9.5-9.5-4.262-9.5-9.5S5.762 1.5 11 1.5"
                mask="url(#401-k-maximizer_svg__b)"
            />
            <path
                fill="#182744"
                d="M12.604 10.445c-.454-.262-.938-.458-1.416-.665a3 3 0 0 1-.778-.452c-.461-.384-.372-1.001.17-1.245.154-.068.313-.092.478-.104a3.54 3.54 0 0 1 1.794.366c.283.14.378.098.472-.207.1-.324.183-.647.277-.97.06-.221-.012-.361-.212-.452a4.3 4.3 0 0 0-1.127-.348c-.513-.086-.513-.086-.513-.617C11.743 5 11.743 5 11.017 5h-.32c-.341.012-.401.074-.406.427-.005.16 0 .318 0 .477 0 .47-.005.464-.443.629-1.056.396-1.705 1.14-1.775 2.33-.066 1.052.466 1.766 1.303 2.284.514.318 1.086.507 1.629.757.212.098.413.208.596.36.525.446.43 1.197-.194 1.478a1.87 1.87 0 0 1-1.045.14 4.6 4.6 0 0 1-1.593-.495c-.296-.158-.378-.115-.478.214q-.13.43-.242.86c-.1.385-.065.477.289.66.454.226.938.343 1.434.428.389.06.4.08.407.5q-.002.284.006.568c0 .238.11.379.348.379q.403.009.808 0c.219-.007.337-.13.337-.361 0-.256.012-.52 0-.775-.012-.263.1-.396.342-.464.56-.16 1.045-.47 1.41-.934 1.02-1.3.625-3.18-.826-4.017"
            />
        </g>
    </svg>
)
export default Svg401KMaximizer
